module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_3.0abbe8e4.png";